import { createTheme } from '@material-ui/core/styles'
import ThemeSwitcher from './../ThemeSwitcher/ThemeSwitcher'

const ThemeColors = ThemeSwitcher(true);

export default createTheme({
  overrides: {
    MuiGrid: {
      item: {
        alignSelf: "center !important",
      },
    },
    MuiPopover: {
      paper: {
        borderRadius: "0.3rem",
        marginTop: "5px",
        transform: "translateX(-5px) !important",
      },
    },
    MuiTooltip: {
      tooltip: {
        border: `1px solid ${ThemeColors[6]}`,
        fontSize: '.8rem',
        color: ThemeColors[13],
        backgroundColor: ThemeColors[7],
        direction: 'rtl',
      },
    }
  },

  // direction: "ltr",

  typography: {
    useNextVariants: true,
    fontFamily: ["Caviar", "Roboto", "iranyekanwebregular"].join(","),
  },

  palette: {
    type: "dark",
    text: { primary: ThemeColors[2], secondary: ThemeColors[8] },
    // primary: {
    //   main: ThemeColors[0],
    // },
    // secondary: {
    //   main: ThemeColors[1],
    // },
    background: {
      default: ThemeColors[0],
      paper: ThemeColors[1],
    },
  },

  utils: { drawerWidth: 160, navHeight: 60 },
});
